import fetchServer from "../controllers/fetchServer";
import { enqueueSnackbar } from "notistack";
import { setBanners } from "../redux/reducers/settings/bannerSettingSlice";
import { useDispatch } from "react-redux";

export default function useBanner() {
  const dispatch = useDispatch();
  const getBanners = async (setLoading) => {
    try {
      setLoading && setLoading(true);

      const res = await fetchServer({
        method: "GET",
        url: `/main/v1/banner?limit=0`,
      });

      if (res && (res.status === 200 || res.status === 201)) {
        const responseData = res?.data?.data?.data;
        dispatch(setBanners(responseData));
        return responseData;
      } else {
        enqueueSnackbar(
          res?.data?.message || "Something went wrong. Please try again later.",
          { variant: "error" }
        );
        return []; // ✅ return empty array instead of undefined
      }
    } catch (err) {
      console.error("Error fetching banners:", err);
      enqueueSnackbar("Failed to fetch banners.", { variant: "error" });
      return [];
    } finally {
      setLoading && setLoading(false);
    }
  };

  const getBannersByLocation = async (setLoading, productType, location) => {
    try {
      setLoading && setLoading(true);

      let filterBy = "product";
      let filterValue = productType;

      if (location) {
        filterBy += ",location";
        filterValue += `,${location}`;
      }

      const res = await fetchServer({
        method: "GET",
        url: `/main/v1/banner?filterBy=${filterBy}&filterValue=${filterValue}`,
      });

      if (res && (res.status === 200 || res.status === 201)) {
        const responseData = res?.data?.data?.data;
        dispatch(setBanners(responseData));
        return responseData;
      } else {
        enqueueSnackbar(
          res?.data?.message || "Something went wrong. Please try again later.",
          { variant: "error" }
        );
        return [];
      }
    } catch (err) {
      console.error("Error fetching banners:", err);
      enqueueSnackbar("Failed to fetch banners.", { variant: "error" });
      return [];
    } finally {
      setLoading && setLoading(false);
    }
  };

  const deleteBanner = async (setLoading, id) => {
    setLoading && setLoading(true);

    await fetchServer({
      method: "DELETE",
      url: `/main/v1/banner/${id}`,
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message || "Training Module deleted successfully!",
              {
                variant: "success",
              }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                "Failed to delete training. please try again .",
              {
                variant: "error",
              }
            );
          }
        }
      })
      .catch((err) => {});

    setLoading && setLoading(false);
  };

  const saveBanner = async (
    setLoading,
    payload,
    id = null,
    method = "POST"
  ) => {
    setLoading && setLoading(true);

    await fetchServer({
      method,
      url: id ? `/main/v1/banner/${id}` : `/main/v1/banner`,
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "Training updated successfully!"
                  : "Training created successfully!"),
              { variant: "success" }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "Failed to update Training!"
                  : "Failed to create Training!"),
              { variant: "error" }
            );
          }
        }
      })
      .catch((err) => {
        enqueueSnackbar("Something went wrong!", { variant: "error" });
      });

    setLoading && setLoading(false);
  };

  const toggleBanner = async (setLoading, id) => {
    setLoading && setLoading(true);

    await fetchServer({
      method: "PATCH",
      url: `/main/v1/banner/${id}/toggleActive`,
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message || "Banner  status toggled successfully!",
              {
                variant: "success",
              }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                "Failed to update banner status. please try again",
              {
                variant: "error",
              }
            );
          }
        }
      })
      .catch((err) => {});

    setLoading && setLoading(false);
  };

  const saveLocation = async (
    setLoading,
    payload,
    id = null,
    method = "POST"
  ) => {
    setLoading && setLoading(true);

    await fetchServer({
      method,
      url: id ? `/main/v1/bannerLocation/${id}` : `/main/v1/bannerLocation`,
      data: payload,
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "location updated successfully!"
                  : "location created successfully!"),
              { variant: "success" }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "Failed to update location!"
                  : "Failed to create location!"),
              { variant: "error" }
            );
          }
        }
      })
      .catch((err) => {
        enqueueSnackbar("Something went wrong!", { variant: "error" });
      });

    setLoading && setLoading(false);
  };

  const deleteLocation = async (setLoading, id) => {
    setLoading && setLoading(true);

    await fetchServer({
      method: "DELETE",
      url: `/main/v1/bannerLocation/${id}`,
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message || "Location  deleted successfully!",
              {
                variant: "success",
              }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                "Failed to delete Location. please try again .",
              {
                variant: "error",
              }
            );
          }
        }
      })
      .catch((err) => {});

    setLoading && setLoading(false);
  };

  const getLocations = async (setLoading) => {
    try {
      setLoading && setLoading(true);

      const res = await fetchServer({
        method: "GET",
        url: `/main/v1/bannerLocation?limit=0`,
      });

      if (res && (res.status === 200 || res.status === 201)) {
        const responseData = res?.data?.data?.data;
        return responseData;
      } else {
        enqueueSnackbar(
          res?.data?.message || "Something went wrong. Please try again later.",
          { variant: "error" }
        );
        return [];
      }
    } catch (err) {
      console.error("Error fetching locatons:", err);
      enqueueSnackbar("Failed to fetch locatons.", { variant: "error" });
      return [];
    } finally {
      setLoading && setLoading(false);
    }
  };

  return {
    getBanners,
    deleteBanner,
    toggleBanner,
    saveBanner,
    saveLocation,
    deleteLocation,
    getLocations,
    getBannersByLocation,
  };
}
